<template>
  <div>
    <v-container fluid class="ma-0 pa-0 mb-5 pb-2" style="background-color:#FAFAFA">
      <v-carousel hide-delimiters="trues" interval="6000000">
        <v-carousel-item>
          <div class="homeBanner">
            <img src="../../assets/fundal.png" alt class="fundal">
            <img src="../../assets/banda_traditionala.png" alt class="banda">
            <img src="../../assets/Layer1.png" alt class="dansatori">
          </div>
        </v-carousel-item>

        <v-carousel-item>
          <img
            src="../../assets/home_carousel/compressed/backup/6-min[cropped].jpg"
            alt
            class="fundal"
          >
        </v-carousel-item>

        <v-carousel-item>
          <img
            src="../../assets/home_carousel/compressed/backup/7-min[cropped].jpg"
            alt
            class="fundal"
          >
        </v-carousel-item>

        <v-carousel-item>
          <img
            src="../../assets/home_carousel/compressed/backup/8-min[cropped].jpg"
            alt
            class="fundal"
          >
        </v-carousel-item>

        <v-carousel-item>
          <img
            src="../../assets/home_carousel/compressed/backup/9-min[cropped].jpg"
            alt
            class="fundal"
          >
        </v-carousel-item>

        <v-carousel-item>
          <img
            src="../../assets/home_carousel/compressed/backup/10-min[cropped].jpg"
            alt
            class="fundal"
          >
        </v-carousel-item>

        <v-carousel-item>
          <img
            src="../../assets/home_carousel/compressed/backup/11-min[cropped].jpg"
            alt
            class="fundal"
          >
        </v-carousel-item>

        <v-carousel-item>
          <img
            src="../../assets/home_carousel/compressed/backup/12-min[cropped].jpg"
            alt
            class="fundal"
          >
        </v-carousel-item>

        <v-carousel-item>
          <img
            src="../../assets/home_carousel/compressed/backup/13-min[cropped].jpg"
            alt
            class="fundal"
          >
        </v-carousel-item>

        <v-carousel-item>
          <img
            src="../../assets/home_carousel/compressed/backup/14-min[cropped].jpg"
            alt
            class="fundal"
          >
        </v-carousel-item>

        <v-carousel-item>
          <img
            src="../../assets/home_carousel/compressed/backup/15-min[cropped].jpg"
            alt
            class="fundal"
          >
        </v-carousel-item>

        <v-carousel-item>
          <img
            src="../../assets/home_carousel/compressed/backup/16-min[cropped].jpg"
            alt
            class="fundal"
          >
        </v-carousel-item>

        <v-carousel-item>
          <img
            src="../../assets/home_carousel/compressed/backup/17-min[cropped].jpg"
            alt
            class="fundal"
          >
        </v-carousel-item>

        <v-carousel-item>
          <img
            src="../../assets/home_carousel/compressed/backup/1-min[cropped].jpg"
            alt
            class="fundal"
          >
        </v-carousel-item>

        <v-carousel-item>
          <img
            src="../../assets/home_carousel/compressed/backup/2-min[cropped].jpg"
            alt
            class="fundal"
          >
        </v-carousel-item>

        <v-carousel-item>
          <img
            src="../../assets/home_carousel/compressed/backup/3-min[cropped].jpg"
            alt
            class="fundal"
          >
        </v-carousel-item>

        <v-carousel-item>
          <img
            src="../../assets/home_carousel/compressed/backup/4-min[cropped].jpg"
            alt
            class="fundal"
          >
        </v-carousel-item>

        <v-carousel-item>
          <img
            src="../../assets/home_carousel/compressed/backup/5-min[cropped].jpg"
            alt
            class="fundal"
          >
        </v-carousel-item>
      </v-carousel>
      <!-- End home page carousel here -->
      <!-- Start feature -->
      <!-- Top artefacts -->
      <v-layout justify-center style="background-color:#FAFAFA" class="mt-4">
        <v-flex xs12 md10 style>
          <v-container fluid class="ma-0 pa-0">
            <v-toolbar-title class="body-2 grey--text ml-4" style>
              <h5 class="mt-3 toolbarTitles">{{gLang[lang].home.featuredArtefacts}}</h5>
            </v-toolbar-title>

            <v-card flat class="pt-3 pb-3" style="background-color:transparent">
              <web-description-swiper></web-description-swiper>
            </v-card>
          </v-container>

          <!-- Top collection -->
          <v-container fluid class="ma-0 pa-0 mt-4">
            <v-toolbar-title class="body-2 grey--text mt-4 ml-4" style>
              <h5 class="toolbarTitles">{{gLang[lang].home.MostViewed}}</h5>
            </v-toolbar-title>

            <v-card flat class="pt-3 pb-3" style="background-color:transparent">
              <!-- <web-slider1>
        <div v-for="(artefact,i) in popularArtefacts" :key="artefact._id" v-if="i<5">
          

   
        <web-artefact-card-mini   :artefact='artefact'></web-artefact-card-mini>
 <web-3-artefacts-card :artefact='[popularArtefacts[i], popularArtefacts[i+1], popularArtefacts[i+2], popularArtefacts[i+3] ]'>
   </web-3-artefacts-card>
        </div>
       
              </web-slider1>-->
              <swiper class="hidden-sm-and-down" :options="swiperOption">
                <swiper-slide v-for="(artefact,i) in sliderArtefacts.slice(0,4)" :key="i">
                  <web-3-artefacts-card :artefact="sliderArtefacts[i]"></web-3-artefacts-card>
                </swiper-slide>

                <div class="swiper-pagination" slot="pagination"></div>
                <div class="swiper-button-prev" slot="button-prev"></div>
                <div class="swiper-button-next" slot="button-next"></div>
              </swiper>

              <swiper class="hidden-md-and-up" :options="swiperOption3">
                <swiper-slide v-for="(artefact,i) in popularArtefacts.slice(0,10)" :key="i">
                  <web-artefact-card-mini :artefact="artefact" :height="200"></web-artefact-card-mini>
                </swiper-slide>

                <div class="swiper-pagination" slot="pagination"></div>
                <div class="swiper-button-prev" slot="button-prev"></div>
                <div class="swiper-button-next" slot="button-next"></div>
              </swiper>
            </v-card>
          </v-container>

          <!-- Top groups -->
          <v-container fluid class="ma-0 pa-0 mt-4">
            <v-toolbar-title class="body-2 grey--text mt-4 ml-4" style>
              <h5 class="toolbarTitles">{{gLang[lang].home.MostFavourited}}</h5>
            </v-toolbar-title>
            <!-- <v-card flat class="pt-3 pb-3" style="background-color:#FAFAFA">
      <web-slider1 ref="slick3">
        <div v-for="(group,i) in popularGroups" :key="i" v-if="i<5">
        <web-group-card  :group='group' :collections='collections'></web-group-card>
        </div>
      </web-slider1>
            </v-card>-->
            <web-list-swiper></web-list-swiper>
          </v-container>
        </v-flex>
      </v-layout>

      <!-- Top groups -->
    </v-container>
    <!-- End feature -->
    <web-speed-dial-add v-if="isMod||isContrib"></web-speed-dial-add>
  </div>
</template>


<script>
import "@/../static/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  data() {
    return {
      sliderArtefacts1: [],
      homeText: " explore your culture" + " \n " + " beyond limits",
      direction: "left",
      fab: false,
      fling: false,
      hover: false,
      tabs: null,
      top: false,
      right: true,
      bottom: true,
      left: false,
      transition: "slide-y-reverse-transition",
      gradient: "to top right, rgba(63,81,181, .7), rgba(25,32,72, .0)",
      show: "Categories",
      sorting: 2,
      swiperOption: {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      swiperOption3: {
        slidesPerView: 2,
        slidesPerColumn: 2,
        spaceBetween: 10,

        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      }
    };
  },

  beforeMount() {
    this.$store.dispatch("loadCollections");
    this.$store.dispatch("loadArtefacts");
    this.$store.dispatch("loadGroups");
  },
  components: {
    swiper,
    swiperSlide
  },
  computed: {
    gLang() {
      return this.$store.getters.loadGlobLang;
    },
    sliderArtefacts() {
      var i;
      for (i = 0; i < this.popularArtefacts.length; i++) {
        if (i % 4 == 0) {
          this.sliderArtefacts1[parseInt(i / 4)] = [
            this.popularArtefacts[i],
            this.popularArtefacts[i + 1],
            this.popularArtefacts[i + 2],
            this.popularArtefacts[i + 3]
          ];
        }
      }
      return this.sliderArtefacts1;
    },
    popularArtefacts() {
      return this.$store.getters.loadPopularArtefacts;
    },
    popularCollections() {
      return this.$store.getters.loadPopularCollections;
    },
    popularGroups() {
      return this.$store.getters.loadPopularGroups;
    },
    collections() {
      return this.$store.getters.loadAllCollections;
    },
    artefacts() {
      return this.$store.getters.loadArtefacts;
    },
    groups() {
      return this.$store.getters.loadGroups;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isMod() {
      return this.$store.getters.isMod;
    },
    isContrib() {
      return this.$store.getters.isContrib;
    }
  },
  methods: {
    showContent(collection) {
      // console.log(this.artefacts);
      // console.log(this.artefacts[6]);
      // console.log(this.artefacts.length);
      var i;
      for (i = 0; i < this.artefacts.length; i++) {
        if (this.artefacts[i].collectionId.indexOf(collection.title) > -1) {
          return true;
        }
      }
      return false;
    },
    showContentGroup(group) {
      // console.log(this.artefacts);
      // console.log(this.artefacts[6]);
      // console.log(this.artefacts.length);
      var i;
      for (i = 0; i < this.collections.length; i++) {
        if (this.collections[i].groups.indexOf(group.title) > -1) {
          return true;
        }
      }
      return false;
    },
    minimize(str, spaces) {
      if (str.split(" ").length < spaces) return str;
      else
        return (
          str
            .split(" ")
            .slice(0, spaces - 1)
            .join(" ") + "..."
        );
    },
    // moveButton(admin) {
    //     if(admin) {
    //       var btn = document.getElementById('bottom_button');
    //       btn.style.bottom = '65px';

    //     }
    //     else
    //     {
    //       var btn = document.getElementById('bottom_button');
    //       btn.style.bottom = '15px';
    //     }
    //   },
    isLast(idart, coltitle) {
      var j,
        k = [];

      for (j = 0; j < this.artefacts.length; j++)
        if (this.artefacts[j].collectionId.indexOf(coltitle) > -1)
          k.push(this.artefacts[j]._id);

      if (k[k.length - 1] == idart) return true;
      else return false;
    }
  },
  mounted() {
    document.title = "HeRA Home";
    window.scrollTo(0, 0);
  },
  created() {
    this.$store.dispatch("loadCollections");
    this.$store.dispatch("loadArtefacts");
    this.$store.dispatch("loadGroups");
    this.$store.dispatch("loadLanguages");
  }
};
</script>

<style>
.carousel-text {
  top: 32%;
  left: 32%;
  font-size: 4vw;
  position: absolute;
  z-index: 1;
}
.carousel__controls {
  display: none !important;
}

.carousel__left .btn__content {
  color: black;
}
.carousel__right .btn__content {
  color: black;
}
.carousel {
  height: 27vh;
}

.carousel__item {
  background-position: center bottom;
}
</style>


<style src='@/../node_modules/slick-carousel/slick/slick.css'>
</style>

<style scoped>
.homeBanner {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.homeBanner .dansatori,
.homeBanner .fundal,
.homeBanner .banda {
  position: absolute;
  top: 0px;
  width: 100%;

  height: auto;
}

.homeBanner .dansatori {
  transform: scale(0.3);
  /* left:18%; */
}
@media screen and (min-width: 1400px) {
  .homeBanner .dansatori {
    top: 50px;
    /* left:18%; */
  }
}

.homeBanner .fundal {
  opacity: 0.7;
  position: relative;
}

.home .toolbarTitles {
  color: black;
  font-weight: 200;
}

.homeHeaderText {
  color: white !important;
  font-weight: 100;
  font-size: 4.4em;
}
.homeHeaderText2 {
  color: white !important;
  font-weight: 100;
  font-size: 2.4em;
}

.girlsImage {
  right: 0px;
}

@media screen and (max-width: 1200px) {
  .homeHeaderText {
    /* color:     background-color: white !important; */
    font-weight: 100;
    font-size: 3.4em;
  }
}

@media screen and (max-width: 1400px) {
  .girlsImage {
    /* right:-80px; */
  }
}
</style>

<style src='@/../node_modules/slick-carousel/slick/slick.css'>
</style>
<style src='@/../static/swiper.css'>
</style>


// WEBPACK FOOTER //
// src/components/Common/Home.vue